// extracted by mini-css-extract-plugin
export default {"radioLabel":"question-module___radioLabel___cca384a1","questionAnswer":"question-module___questionAnswer___a369b0ac"};